<template>
    <div class="content">
        <p v-if="selectedAreaHasNoTableData">
            {{ $t("App.Legend.SelectedAreaDataUnavailable") }}
        </p>
        <dynamic-table
            v-else
            :table-data="markerData"
        />
        <br>
        <p>{{ infotext }}</p>
        <p
            v-if="(!rightSlotData.id)"
            class="content-text-info"
        >
            {{ $t("App.RightSlot.SelectArea") }}
        </p>
    </div>
</template>

<script lang="ts">
    import { Component, Vue } from "vue-facing-decorator"
    import DynamicTable from "@/components/DynamicTable.vue"
    import TableData from "@/models/tabledata"
    import DynamicRightSlotData from "@/models/dynamicrighslotdata"
    import { store } from '@/store/store'

    @Component({
        components: {
            "dynamic-table": DynamicTable
        }
    })

    export default class LiikennekaytossaHenkiloAutotKeskiIka extends Vue {
        get rightSlotData(): DynamicRightSlotData {
            return store.getters.rightSlotData
        }

        get markerData() {
            return new TableData(this.rightSlotData?.tableData?.header ?? [], this.rightSlotData?.tableData?.data ?? [], null)
        }

        get infotext(): string | undefined {
            return this.$t("App.TieLiikenne.LiikennekaytossaHenkiloAutotKeskiIka.RightSlotInfotext", [store.getters.dataYear])
        }

        // checks that a area has been selected and it does not have table data
        get selectedAreaHasNoTableData() {
            return this.rightSlotData?.municipality === ""
        }
    }
</script>
